import './style.scss'
import { useState } from 'react'
import utility from 'src/utils/utility'
import { useNavigate } from 'react-router-dom'
import { AbsoluteContainer, AppLabel, AppLink, Button, Circle, CustomContainer, FlexColumn, FlexRow } from 'src/style'
import { WelcomeFrame } from 'src/component'
import { BiSupport } from 'react-icons/bi'
import { IoAnalytics, IoWarningOutline, IoDocumentTextOutline, IoChevronForwardOutline } from 'react-icons/io5'
import { GoFile } from 'react-icons/go'
import { GiMicroscopeLens } from 'react-icons/gi'
import { MdOutlineManageSearch } from 'react-icons/md'
import { HiOutlineUserGroup } from 'react-icons/hi'


const UserType: React.FC = () => {
    const navigate = useNavigate()
    const [type, setType] = useState('')
    
    return (
        <FlexRow 
            height='100' hUnit='%' topPadding='1.5' width='100' 
            sizeUnit='%' justifyContent='flex-start'
            bottomPadding='1.5' leftPadding='1' rightPadding='1'
        >
            <WelcomeFrame />
            <FlexColumn 
                height='100' hUnit='%' width='63'
                sizeUnit='%' radius='0.8'
                leftPadding='6' rightPadding='6'
                className='admin-types-block'
            >
                <AbsoluteContainer top='0' right='6'>
                    <AppLink 
                        decoration='none' color='#101225' textSize='1.2' hoverColor='#4C6FFF'
                        style={{backgroundColor: '#FAFAFA'}}
                    >
                        Got questions?
                    </AppLink>
                </AbsoluteContainer>
                <AbsoluteContainer bottom='0' left='6'>
                    <AppLink 
                        decoration='none' color='#425466' textSize='1' fontWeight='600'
                        style={{backgroundColor: '#FAFAFA'}}
                    >
                        Crendly support panel 2022
                    </AppLink>
                </AbsoluteContainer>
                <CustomContainer overflow='auto'>
                    <AppLabel textSize='2' fontWeight='600' color='#000000'>
                        Choose your user type
                    </AppLabel>
                    <CustomContainer className='admin-types-wrapper'>
                        <FlexRow gap='1.5' wrap='wrap'>
                            <FlexColumn 
                                width='16.3' height='19.4' bgColor='#ffffff'
                                borderColor='#E2E8F0' radius='0.8' bottomMargin='1.2'
                                className='admin-type'
                                onClick={() => setType('Customer Support')}
                            >
                                <Circle 
                                    size='6.5' bottomMargin='3.5'
                                    bgColor={type === 'Customer Support' ? '#E1E8FF' : '#FAFAFA'} 
                                >
                                    <BiSupport 
                                        style={{fontSize: '3.5rem', color: type === 'Customer Support' ? '#3754DB' : '#425466'}} 
                                    />
                                </Circle>
                                <AppLabel color={type === 'Customer Support' ? '#101225' : '#4A5568'}>Customer Support</AppLabel>
                            </FlexColumn>
                            <FlexColumn 
                                width='16.3' height='19.4' bgColor='#ffffff'
                                borderColor='#E2E8F0' radius='0.8' bottomMargin='1.2'
                                className='admin-type'
                                onClick={() => setType('Sales & Marketing')}
                            >
                                <Circle 
                                    size='6.5' bottomMargin='3.5'
                                    bgColor={type === 'Sales & Marketing' ? '#E1E8FF' : '#FAFAFA'} 
                                >
                                    <IoAnalytics 
                                        style={{fontSize: '3.5rem', color: type === 'Sales & Marketing' ? '#3754DB' : '#425466'}}  
                                    />
                                </Circle>
                                <AppLabel color={type === 'Sales & Marketing' ? '#101225' : '#4A5568'}>Sales & Marketing</AppLabel>
                            </FlexColumn>
                            <FlexColumn 
                                width='16.3' height='19.4' bgColor='#ffffff'
                                borderColor='#E2E8F0' radius='0.8' bottomMargin='1.2'
                                className='admin-type'
                                onClick={() => setType('Compliance')}
                            >
                                <Circle 
                                    size='6.5' bottomMargin='3.5'
                                    bgColor={type === 'Compliance' ? '#E1E8FF' : '#FAFAFA'} 
                                >
                                    <GoFile 
                                        style={{fontSize: '3.5rem', color: type === 'Compliance' ? '#3754DB' : '#425466'}}  
                                    />
                                </Circle>
                                <AppLabel color={type === 'Compliance' ? '#101225' : '#4A5568'}>Compliance</AppLabel>
                            </FlexColumn>
                            <FlexColumn 
                                width='16.3' height='19.4' bgColor='#ffffff'
                                borderColor='#E2E8F0' radius='0.8' bottomMargin='1.2'
                                className='admin-type'
                                onClick={() => setType('Fraud Monitoring')}
                            >
                                <Circle 
                                    size='6.5' bottomMargin='3.5'
                                    bgColor={type === 'Fraud Monitoring' ? '#E1E8FF' : '#FAFAFA'} 
                                >
                                    <GiMicroscopeLens 
                                        style={{fontSize: '3.5rem', color: type === 'Fraud Monitoring' ? '#3754DB' : '#425466'}}
                                    />
                                </Circle>
                                <AppLabel color={type === 'Fraud Monitoring' ? '#101225' : '#4A5568'}>Fraud Monitoring</AppLabel>
                            </FlexColumn>
                            <FlexColumn 
                                width='16.3' height='19.4' bgColor='#ffffff'
                                borderColor='#E2E8F0' radius='0.8' bottomMargin='1.2'
                                className='admin-type'
                                onClick={() => setType('Risk Underwriting')}
                            >
                                <Circle 
                                    size='6.5' bottomMargin='3.5'
                                    bgColor={type === 'Risk Underwriting' ? '#E1E8FF' : '#FAFAFA'} 
                                >
                                    <IoWarningOutline 
                                        style={{fontSize: '3.5rem', color: type === 'Risk Underwriting' ? '#3754DB' : '#425466'}}
                                    />
                                </Circle>
                                <AppLabel color={type === 'Risk Underwriting' ? '#101225' : '#4A5568'}>Risk Underwriting</AppLabel>
                            </FlexColumn>
                            <FlexColumn 
                                width='16.3' height='19.4' bgColor='#ffffff'
                                borderColor='#E2E8F0' radius='0.8' bottomMargin='1.2'
                                className='admin-type'
                                onClick={() => setType('Audit & Control')}
                            >
                                <Circle 
                                    size='6.5' bottomMargin='3.5'
                                    bgColor={type === 'Audit & Control' ? '#E1E8FF' : '#FAFAFA'}
                                >
                                    <IoDocumentTextOutline 
                                        style={{fontSize: '3.5rem', color: type === 'Audit & Control' ? '#3754DB' : '#425466'}}
                                    />
                                </Circle>
                                <AppLabel color={type === 'Audit & Control' ? '#101225' : '#4A5568'}>Audit & Control</AppLabel>
                            </FlexColumn>
                            <FlexColumn 
                                width='16.3' height='19.4' bgColor='#ffffff'
                                borderColor='#E2E8F0' radius='0.8' bottomMargin='1.2'
                                className='admin-type'
                                onClick={() => setType('Management')}
                            >
                                <Circle 
                                    size='6.5' bottomMargin='3.5'
                                    bgColor={type === 'Management' ? '#E1E8FF' : '#FAFAFA'}
                                >
                                    <MdOutlineManageSearch 
                                        style={{fontSize: '3.5rem', color: type === 'Management' ? '#3754DB' : '#425466'}}
                                    />
                                </Circle>
                                <AppLabel color={type === 'Management' ? '#101225' : '#4A5568'}>Management</AppLabel>   
                            </FlexColumn>
                            <FlexColumn 
                                width='16.3' height='19.4' bgColor='#ffffff'
                                borderColor='#E2E8F0' radius='0.8' bottomMargin='1.2'
                                className='admin-type'
                                onClick={() => setType('Admin')}
                            >
                                <Circle 
                                    size='6.5' bottomMargin='3.5'
                                    bgColor={type === 'Admin' ? '#E1E8FF' : '#FAFAFA'}
                                >
                                    <HiOutlineUserGroup 
                                        style={{fontSize: '3.5rem', color: type === 'Admin' ? '#3754DB' : '#425466'}}
                                    />
                                </Circle>
                                <AppLabel color={type === 'Admin' ? '#101225' : '#4A5568'}>Admin</AppLabel>  
                            </FlexColumn>
                        </FlexRow>
                    </CustomContainer>
                    <Button
                        width='13.4' height='4.3' fontWeight='600'
                        hoverBgColor='#ffffff' hoverColor='#4C6FFF'
                        borderColor='#4C6FFF' topMargin='4' bottomMargin='2.5'
                        disabled={!type ? true : false}
                        className='app-btn'
                        onClick={() => navigate('/login')}
                    >
                        Continue <IoChevronForwardOutline style={{marginLeft: '1rem'}} />
                    </Button>
                </CustomContainer>
            </FlexColumn>
        </FlexRow>
    )
}

export default utility.routeData('/', 'User Type', <UserType/>)